<template>
  <router-link
    v-if="showItem"
    :to="view.getUrl(tag)"
    class="categories-filter__item"
  >
    <div class="categories-filter__icon-box">
      <img
        class="categories-filter__icon"
        :src="view.tagIcon(tag)"
        :alt="tag"
      />
    </div>
    <h3 class="categories-filter__name">{{ tag }}</h3>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { DocsTagsView as CategoriesView } from '@/models/docs.tags'

const props = withDefaults(
  defineProps<{
    tag: string
    view: CategoriesView
    isMobile?: boolean
    itemIndex?: number
  }>(),
  {
    isMobile: false,
    itemIndex: 0,
  },
)

const showItem = computed(() => {
  if (props.isMobile) {
    return true
  }

  return props.view.showAllTags || props.itemIndex < 6
})
</script>

<style lang="scss" scoped>
.categories-filter {
  &__item {
    width: 100%;
    border-radius: 8px;
    background-color: $c-yellow-2;
    border: 1px solid $c-yellow-2;
    padding: 12px 16px;
    text-align: center;
    transition: border 0.2s ease-in-out;

    @include hover {
      border-color: $c-yellow;
    }

    @media only screen and (max-width: $w-tablet-s) {
      width: 140px;
      padding: 10px 12px;
    }
  }
  &__icon-box {
    margin-bottom: 8px;
  }
  &__icon {
    width: 60px;
    aspect-ratio: 1 / 1;
    display: block;
    margin: 0 auto;
    @media only screen and (max-width: $w-tablet-s) {
      width: 40px;
    }
  }
  &__name {
    font-weight: 500;
    font-size: 14px;
    color: $c-black-15;
    margin-bottom: 2px;
    margin-top: 10px;
    line-height: 16px;
  }
}

.night-mode .categories-filter {
  &__item {
    background: $c-yellow-9;
    border-color: $c-yellow-9;
    @include hover {
      border-color: $c-yellow;
    }
  }
  &__name {
    color: $c-dark-4;
  }
}
</style>
